import { LorenPrivilegeEntityType } from "../../../../../../../../features/loren-roles/interfaces/loren-role.interface";
import { LOREN_ROUTES } from "../../../../../../../constants/loren-routes.constants";
import { LorenSidenavTourSteps } from "../../../../../../../constants/loren-tour-steps.constants";
import { LorenFeature } from "../../../../../../../enums/loren-feature.enum";
import { LorenMenuItem } from "../../../interfaces/loren-menu-item.interface";

const geofencingMenuItem = {
  title: "toolbar.geofencing",
  path: LOREN_ROUTES.GEOFENCING,
  featureToggle: LorenFeature.GENERIC_MAP_GEOZONES,
  tourAnchorId: LorenSidenavTourSteps[2].anchorId,
};

const groupsMenuItem = {
  title: "toolbar.groups",
  path: LOREN_ROUTES.GROUPS,
  featureToggle: LorenFeature.GROUPS,
  tourAnchorId: LorenSidenavTourSteps[7].anchorId,
};

const rulesMenuItem = {
  title: "toolbar.automation_plans",
  path: LOREN_ROUTES.PLANS,
  featureToggle: LorenFeature.GENERIC_RULES,
  tourAnchorId: LorenSidenavTourSteps[5].anchorId,
};

const accessMenuItem = {
  title: "toolbar.access",
  path: LOREN_ROUTES.USER_ACCESS,
  privileges: [LorenPrivilegeEntityType.WRITE_ROLE],
};

const rolesMenuItem = {
  title: "toolbar.roles",
  path: LOREN_ROUTES.ROLES,
  privileges: [LorenPrivilegeEntityType.WRITE_ROLE],
};

const notificationsMenuItem = {
  title: "toolbar.notifications",
  path: LOREN_ROUTES.NOTIFICATIONS_SETTINGS,
};

const devicesMenuItem = {
  title: "toolbar.devices",
  path: LOREN_ROUTES.DEVICES,
  featureToggle: LorenFeature.DEVICE_REPORT,
};

export const ASSET_SETTINGS_MENU_ITEMS: Partial<LorenMenuItem>[] = [
  geofencingMenuItem,
  groupsMenuItem,
  rulesMenuItem,
  notificationsMenuItem,
  devicesMenuItem,
];

export const USERS_SETTINGS_MENU_ITEMS: Partial<LorenMenuItem>[] = [
  accessMenuItem,
  rolesMenuItem,
];
